import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { HttpException } from '../../../../exceptions/index';
import { useAppMutation, useLocale } from '../../../../hooks/index';
import ApiService from '../../../../services/api-service.util';

type SendSignatureReminderResponse = {
  sentCount: number;
};

export const useSendSignatureReminder = () => {
  const queryClient = useQueryClient();
  const { messagesLocale } = useLocale();

  const { isPending, mutateAsync: sendSignatureReminder } = useAppMutation<
    SendSignatureReminderResponse,
    HttpException,
    string
  >([QueryKey.SEND_SIGNATURE_REMINDER], {
    mutationFn: (signatureId: string) =>
      ApiService.post<SendSignatureReminderResponse>(
        { endpoint: BackendRoute.SIGNATURES, routePath: [signatureId, 'send-reminder'] },
        { body: {} },
      ),
    onSuccess: () => {
      toast.success(messagesLocale['REMINDER_SENT_SUCCESSFULLY']);
      void queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SIGNATURES] });
    },
  });

  return { isPending, sendSignatureReminder };
};
